import { Typography, type TypographyProps, styled } from '@mui/material';
import { WithTheme } from '@issuemanager/apps/client/theme';

export type ExtendedVariants =
  | 'labelSm'
  | 'label'
  | 'textSm'
  | 'textMd'
  | 'textXs'
  | 'titleSm'
  | 'emphasis'
  | 'link';

export interface ExtendedTypographyProps
  extends Omit<TypographyProps, 'variant'> {
  variant?: TypographyProps['variant'] | ExtendedVariants;
}

const isExtendedVariant = (
  variant: TypographyProps['variant'] | ExtendedVariants,
): variant is ExtendedVariants =>
  [
    'labelSm',
    'label',
    'textXs',
    'textSm',
    'textMd',
    'titleSm',
    'link',
    'emphasis',
  ].includes(variant!);

const StyledTypography = styled(Typography)<WithTheme<ExtendedTypographyProps>>(
  ({ theme, variant }) => {
    // typescript needs a guard to know that variant can be ExtendedVariants.link
    if (isExtendedVariant(variant)) {
      if (variant === 'link') {
        return {
          fontWeight: theme.tokens.semantic.fontWeight.emphasis.value,
          fontSize: theme.tokens.semantic.fontSize.text.body.value,
          color: theme.tokens.semantic.color.link.default.value,
          // TBD: uppercase, hover
        };
      }
    }

    return undefined;
  },
);

export function ExtendedTypography(props: ExtendedTypographyProps) {
  const { variant, ...rest } = props;
  return (
    <StyledTypography
      // TODO: Remove this when atlas fixes the types
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      variant={variant}
      {...rest}
    />
  );
}
